import { gql } from '@apollo/client'

const UPGRADE_PAGE_FIELDS = gql`
  fragment UpgradePageFields on UpgradePageType {
    id
    createdAt
    updatedAt
    deletedAt
    version
    title
    mainBadge
    secondaryBadge
    showMaxBadge
    isPassGuaranteed
    isForNewUsers
    salesPrice
    originalPrice
    features
    type
    duration
    isSubscription
    mainDescription
    description
  }
`

export const FIND_ALL_UPGRADE_PAGES = gql`
  ${UPGRADE_PAGE_FIELDS}
  query findAllUpgradePage($query: UpgradePageQueryInput!) {
    findAllUpgradePage(query: $query) {
      items {
        ...UpgradePageFields
      }
      count
    }
  }
`

export const UPDATE_UPGRADE_PAGE = gql`
  ${UPGRADE_PAGE_FIELDS}
  mutation UpdateUpgradePage($updateUpgradePageInputFieldName: UpdateUpgradePageInput!) {
    updateUpgradePage(updateUpgradePageInputFieldName: $updateUpgradePageInputFieldName) {
      ...UpgradePageFields
    }
  }
`
